import axios from "axios";
import * as d3 from "d3";
import {fw_progressive_1way} from '../functions'

export default function (chart, divId, vizName, filterParam) {
    var x1AxisLabel = d3.scaleBand().range([0, chart.width]);
    var y1AxisLabel = d3.scaleLinear().domain([0, 2]).clamp(true);
    var metric1ColorScale = d3.scaleOrdinal().range(fw_progressive_1way);

    console.log("vizname is", vizName, filterParam)

    //define svg for building positions
    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId).append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    //load data
    axios({url: '/json/co-occurences-sc.json', baseURL: '', method: 'GET'}).then(res => {
        let datas = res.data
        var matrix = [],
            nodes = datas.nodes,
            n = nodes.length;

        // Compute index per node.
        nodes.forEach(function (node, i) {
            node.index = i;
            node.count = 0;
            matrix[i] = d3.range(n).map(function (j) {
                return {x: j, y: i, z: 0};
            });
        });

        // Convert links to matrix; count character occurrences.
        datas.links.forEach(function (link) {
            matrix[link.source][link.target].z += link.value;
            nodes[link.source].count += link.value;
            nodes[link.target].count += link.value;
        });

        // Precompute the orders.
        var orders = {
            name: d3.range(n).sort(function (a, b) {
                return d3.ascending(nodes[a].name, nodes[b].name);
            }),
            count: d3.range(n).sort(function (a, b) {
                return nodes[b].count - nodes[a].count;
            }),
            group: d3.range(n).sort(function (a, b) {
                return nodes[b].group - nodes[a].group;
            })
        };

        // The default sort order.
        x1AxisLabel.domain(orders.name);

        svg.append("rect")
            .style("fill", "#eee")
            .attr("width", chart.width)
            .attr("height", chart.height);

        var row = svg.selectAll(".row")
            .data(matrix)
            .enter()
            .append("g")
            .attr("class", "row")
            .attr("transform", function (d, i) {
                return "translate(0," + x1AxisLabel(i) + ")";
            })
            .each(newrow);

        row.append("line")
            .attr("x2", chart.width)
            .style("stroke", "#fff");

        row.append("text")
            .attr("dx", "-9em")
            .attr("dy", ".32em")
            .attr("text-anchor", "start")
            .text(function (d, e) {
                if (nodes[e].name.length > 15)
                    return nodes[e].name.substring(0, 15) + "~ "
                else {
                    let j = 15 - nodes[e].name.length;
                    for (let i = 1; i <= j; i++) {
                        nodes[e].name = nodes[e].name + " .";
                    }
                    return nodes[e].name + " ."
                }
            })
        /*.attr("x", -6)
            .attr("y", x1AxisLabel.bandwidth() / 3)
            .attr("dy", ".32em")
            .attr("text-anchor", "end")
            .text(function (d, i) { return nodes[i].name; })*/
        /*  .text(function (d, i) {
                if (nodes[i].name.length > 10)
                    return nodes[i].name.substring(0, 10) + '...'
                else
                    return nodes[i].name
            });
        */

        var column = svg.selectAll(".column")
            .data(matrix)
            .enter().append("g")
            .attr("class", "column")
            .attr("transform", function (d, i) {
                return "translate(" + x1AxisLabel(i) + ")rotate(-90)";
            });

        column.append("line")
            .attr("x1", -chart.width)
            .style("stroke", "#fff");

        column.append("text")
            .attr("x", 6)
            .attr("dy", ".32em")
            .attr("text-anchor", "start")
            .attr('transform', 'rotate(40)')
            .text(function (d, e) {
                if (nodes[e].name.length > 15)
                    return nodes[e].name.substring(0, 15) + "~ "
                else {
                    let j = 15 - nodes[e].name.length;
                    for (let i = 1; i <= j; i++) {
                        nodes[e].name = nodes[e].name + " .";
                    }
                    return nodes[e].name + " ."
                }
            })

        var y1tip = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style('line-height', '1')
            .style('padding', '12px')
            .style('background', 'white')
            .style('border-radius', '5px')
            .style('position', 'absolute')
            .style('border-width', '.1px')
            .style('border-style', 'groove')

        //appending the tooltip to the visualization
        function newrow(row) {
            d3.select(this).selectAll(".cell")
                .data(row.filter((d) => {
                    return d.z
                }))
                .enter().append("rect")
                .attr("class", "cell")
                .attr("x", (d) => {
                    return x1AxisLabel(d.x)
                })
                .attr("width", x1AxisLabel.bandwidth())
                .attr("height", x1AxisLabel.bandwidth())
                .style("fill-opacity", (d) => {
                    return y1AxisLabel(d.z)
                })
                .style("fill", function (d) {
                    return nodes[d.x].group == nodes[d.y].group ? metric1ColorScale(nodes[d.x].group) : null;
                })
                .on("mousemove", mousemove)
                .on("mouseover", mouseover)
                .on("mouseout", mouseout)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding
        }

        //defining functions for tooltips
        function mousemove(d) {
            y1tip.html(d.z)
                .style("left", (d3.event.pageX) + "px")
                .style("top", (d3.event.pageY) + "px")
        }

        function mouseover(p) {
            y1tip.transition()
                .duration(300)
                .style("opacity", 1)
                .style("fill", "red")
            d3.selectAll(".row text").classed("active", function (d, i) {
                return i == p.y;
            });
            d3.selectAll(".column text").classed("active", function (d, i) {
                return i == p.x;
            })
        }

        function mouseout() {
            y1tip.transition()
                .duration(300)
                .style("opacity", 1e-6);
            d3.selectAll("text").classed("active", false);
        }

        d3.select("#order").on("change", function () {
            clearTimeout(timeout);
            order(this.value);
        });
        //displaying the order of color
        var y1legend = svg.selectAll(".legend")
            .data(metric1ColorScale.domain())
            .enter().append("g")
            .attr("class", "legend")
            .attr("transform", function (d, i) {
                return "translate(25," + i * 20 + ")";
            });

        y1legend.append("rect")
            .attr("x", chart.width - 7)
            .attr("width", 18)
            .attr("height", 18)
            .style("fill", metric1ColorScale);

        y1legend.append("text")
            .attr("x", chart.width - 12)
            .attr("y", 13)
            .attr("dy", ".35em")
            .style("text-anchor", "end")
            .text(function (d) {
                return d;
            });

        function order(value) {
            x1AxisLabel.domain(orders[value]);

            var t = svg.transition().duration(2500);

            t.selectAll(".row")
                .delay(function (d, i) {
                    return x1AxisLabel(i) * 4
                })
                .attr("transform", function (d, i) {
                    return "translate(0," + x1AxisLabel(i) + ")"
                })
                .selectAll(".cell")
                .delay(function (d) {
                    return x1AxisLabel(d.x) * 4
                })
                .attr("x", function (d) {
                    return x1AxisLabel(d.x)
                });

            t.selectAll(".column")
                .delay(function (d, i) {
                    return x1AxisLabel(i) * 4
                })
                .attr("transform", function (d, i) {
                    return "translate(" + x1AxisLabel(i) + ")rotate(-90)"
                });
        }

        var timeout = setTimeout(function () {
            order("group");
            d3.select("#order").property("selectedIndex", 2).node().focus();
        }, 5000);
    });

    function responsivefy(svg) {
        // get container + svg aspect ratio
        var container = d3.select(svg.node().parentNode),
            width = parseInt(svg.style("width")),
            height = parseInt(svg.style("height")),
            aspect = width / height;

        // add viewBox and preserveAspectRatio properties,
        // and call resize so that svg resizes on inital page load
        svg.attr("viewBox", "0 0 " + width + " " + height)
            .attr("perserveAspectRatio", "xMinYMid")
            .call(resize);

        d3.select(window).on("resize." + container.attr("id"), resize);

        // get width of container and resize svg to fit it
        function resize() {
            var targetWidth = parseInt(container.style("width"));
            svg.attr("width", targetWidth / 1.15);
            svg.attr("height", Math.round(targetWidth / aspect));
        }
    }
}
